module.exports = __webpack_public_path__ + "static/media/boatramp.e852860b.svg";